import { AdminUserService } from '@services/admin-user-service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConstant } from '@constants/app.constant';
import { TranslateService } from '@ngx-translate/core';
import { ModalDirective, TabsetComponent } from 'ngx-bootstrap';
import { Component, ViewChild, Input, EventEmitter, Output, OnInit, OnDestroy, AfterViewChecked, AfterViewInit, AfterContentInit, ElementRef } from '@angular/core';
import { BinaryFile } from '@app/models/binary-file';
import { FormValidationUtil } from '@app/utils/form.validation';
import { NgForm } from '@angular/forms';
import { map } from 'jquery';
import { Company } from '@app/models/customer/company';

import * as FileSaver from 'file-saver';
import { OnepageField, FieldType } from '@app/models/onepage-template-field';
import { UploadOutput } from 'ngx-uploader';
import { ApplicationFile } from '@app/models/application-file';
import { from } from 'rxjs';
import { mergeMap, reduce, switchMap } from 'rxjs/operators';
import { ErrorResponse } from '@app/models/error.response';
import { BinaryFileService } from '@app/services/binary-file.service';
import { ProductSelector } from '@app/components/product-selector/product-selector.component';
import { OnepageProduct } from '@app/models/onepage-product';
import { OnepageTemplateFieldTypeConfig } from '@app/models/onepage-template';
declare var toastr: any;
const MAX_DOCUMENT_FILE_SIZE: number = 4 * 1024 * 1024;

@Component({
    selector: 'onepage-template-field',
    templateUrl: './onepage-template-field.component.html',
    styleUrls: ['./onepage-template-field.component.scss']
})
export class OnepageTemplateField implements OnInit {
    searchCompany = Company.search;

    @Input() disabled: boolean;
    @Output() onSave: EventEmitter<OnepageField> = new EventEmitter();
    @ViewChild('modal', { static: false }) modal: ModalDirective;
    @ViewChild('modelform', { static: false }) modelform: NgForm;
    @ViewChild('documentFileSelect', { static: false }) documentFileSelect: ElementRef;
    @ViewChild('taskConfigSelector', { static: false }) taskConfigSelector: ProductSelector;
    isFieldError = FormValidationUtil.isFieldError;

    fileLoading: boolean = false;
    binaryFileApplication: ApplicationFile;
    fieldTypeOptions: FieldType[] = ['TEXT', 'DROPDOWN','DATE','EMAIL','PHONE','IMAGE','IMAGE_WITH_CUSTOMIZED_SIZE','IMAGE_IN_ROW1' ,
            'IMAGE_IN_ROW2','LABEL', 'CHECKBOX', 'USER', 'BUTTON', 'BUTTON_CUSTOMIZED_PRICE', 'RADIO', 'T_AND_C'];
    onepageTemplateFieldTypeConfig: OnepageTemplateFieldTypeConfig;

    displayModeOptions = ['IN-BOTH', 'IN-MOBILE', 'IN-DESKTOP'];

  
    labelFontFamilyOptions: string[] =['','Arial','Helvetica','Times New Roman','Courier New','Zeyada','Tecnico','Roboto','Taipei Sans TC Beta'];
    labelFontColor: string="#000000";
    labelFontFamily: string;
    labelFontBold: string;
    labelBackgroundColor: string="#FFFFFF";
    fieldBackgroundColor: string="#FFFFFF";

    record: OnepageField;
    mapData: Map<string, object>
    loading: boolean = false;
    clickSave: boolean = false;
    needInit: boolean = false;
    invalid: boolean = false;

    displayIn: string;
    sequence: number;
    fieldId: string;
    // selectedFieldType: FieldType;
    fieldEnLabel: string;
    fieldTcLabel:string;
    fieldEnLabel2: string;
    fieldTcLabel2:string;
    fieldEnDescLabel: string;
    fieldTcDescLabel: string;
    fieldType:FieldType;
    notNull: boolean = true;
    dropDownValue: string;
    description: string;
    descriptionStyle: string;
    labelStyle: string;
    inputStyle: string;
    location: string;    
    imgFile: BinaryFile;
    checkedAsDefault: boolean = false;
    
    fieldIconCode: string;
    showLabel: boolean = true;
    sameToTheField: string;

    buttonProductPrice: string;
    buttonLabel: string;
    button4ProductName: string;
    button4ProductCode: string;
    insertCustomizedPriceInput: boolean = false;
    
	allowResetProductAmountInUi: boolean = false;
	showButtonAtTheBottom: boolean = false;
    maxProductAmountInOneBuy: number = 1;
    tandcApplyToWord: string;
    tandcApplyToWordTc: string;

    publishLanguage: string;

    needCheckSaveButton: boolean;
    templateFieldLocationOptions: string[]=['default'];
    fieldName: string;

    imageWidth: string='100%';
    imageHeight: string;
    buttonLabelTc: string;
    dropDownValueTc: string;
    validPattern: string;
    paddingTopHeight: string;
    
    defaultSystemField: boolean = false;

    constructor(protected router: Router,
        protected route: ActivatedRoute,
        public appConstant: AppConstant,
        protected translate: TranslateService,
        protected binaryFileService: BinaryFileService) {
    }

    ngOnInit(): void {
        console.debug('init task config selector.')
        this.mapData = new Map();
    }

    allowToShow(fieldId: string): boolean{
        if(this.onepageTemplateFieldTypeConfig){
            var notallow =  this.onepageTemplateFieldTypeConfig.disableUiFieldIdsArr?
                            this.onepageTemplateFieldTypeConfig.disableUiFieldIdsArr.indexOf(fieldId)>=0:false;
            var allow =  this.onepageTemplateFieldTypeConfig.enabledUiFieldIdsArr?
                        this.onepageTemplateFieldTypeConfig.enabledUiFieldIdsArr.indexOf(fieldId)>=0:true;
            if(allow){
                return true;
            }
            if(notallow){
                return false;
            }
        }
        return true;
    }

  
    templateFileName: string;
    public open(record: OnepageField, needCheckSaveButton: boolean, templateFileName: string, publishLanguage: string, fieldTypeOptions?: FieldType[],
        onepageTemplateFieldTypeConfig?: OnepageTemplateFieldTypeConfig): void {
        this.record = record;
        this.publishLanguage = publishLanguage;
        // this.selectedFieldType = this.record.fieldType;
        if(fieldTypeOptions && fieldTypeOptions.length>0){
            this.fieldTypeOptions = fieldTypeOptions;
        }
        this.onepageTemplateFieldTypeConfig = onepageTemplateFieldTypeConfig;
        this.templateFileName = templateFileName;
        this.fieldName = this.record.fieldName;
        this.defaultSystemField = this.record.defaultSystemField;
        this.templateFieldLocationOptions = record.templateFieldLocationOptions;
        this.sequence = this.record.sequence;
        this.fieldId = this.record.fieldId;
        this.fieldEnLabel = this.record.fieldEnLabel;
        this.fieldTcLabel = this.record.fieldTcLabel;
        this.fieldEnLabel2 = this.record.fieldEnLabel2;
        this.fieldTcLabel2 = this.record.fieldTcLabel2;
        this.fieldEnDescLabel = this.record.fieldEnDescLabel;
        this.fieldTcDescLabel = this.record.fieldTcDescLabel;
        this.fieldType = this.record.fieldType;
        this.notNull = this.record.notNull;
        this.dropDownValue = this.record.dropDownValue;
        this.description = this.record.description;
        this.descriptionStyle = this.record.descriptionStyle;
        this.labelStyle = this.record.labelStyle;
        this.inputStyle = this.record.inputStyle;
        this.location = this.record.location;
        this.imgFile = this.record.imgFile;
        this.imageHeight = this.record.imageHeight;
        this.imageWidth = this.record.imageWidth;
        this.buttonLabelTc = this.record.buttonLabelTc;
        this.dropDownValueTc = this.record.dropDownValueTc;
        this.button4ProductCode = this.record.button4ProductCode;
        this.tandcApplyToWord = this.record.tandcApplyToWord;
        this.tandcApplyToWordTc = this.record.tandcApplyToWordTc;
        this.paddingTopHeight = this.record.paddingTopHeight;
        this.labelBackgroundColor = this.record.labelBackgroundColor;
        this.labelFontColor = this.record.labelFontColor;
        this.labelFontFamily = this.record.labelFontFamily;
        this.fieldBackgroundColor = this.record.fieldBackgroundColor;
        this.labelFontBold = this.record.labelFontWeight;
        this.checkedAsDefault = this.record.checkedAsDefault;

        
	    this.allowResetProductAmountInUi = this.record.allowResetProductAmountInUi;   
        this.showButtonAtTheBottom = this.record.showButtonAtTheBottom;
        this.displayIn = this.record.displayIn||this.displayModeOptions[0];
        this.maxProductAmountInOneBuy = this.record.maxProductAmountInOneBuy;
        if(!this.maxProductAmountInOneBuy){
            this.maxProductAmountInOneBuy = 1;
        }

        if(!this.imageWidth){
            this.imageWidth = '100%';
        }
        
        this.fieldIconCode = this.record.fieldIconCode;
        this.showLabel= this.record.showLabel;
        this.sameToTheField= this.record.sameToTheField;
        this.validPattern = this.record.validPattern;

        this.buttonProductPrice = this.record.buttonProductPrice;
        this.buttonLabel= this.record.buttonLabel;
        this.button4ProductName = this.record.button4ProductName;
        this.insertCustomizedPriceInput= this.record.insertCustomizedPriceInput;

        this.needCheckSaveButton = needCheckSaveButton;
        this.ngOnInit();
        this.needInit = true;
        this.clickSave = false;
        this.modal.show();
    }

      onFieldTypeChange(taskType: FieldType) {
        if(taskType!='BUTTON' && taskType!='BUTTON_CUSTOMIZED_PRICE'){
            this.allowResetProductAmountInUi = false;
            this.showButtonAtTheBottom = false;
            this.maxProductAmountInOneBuy = 1;
        }

        if (this.record.fieldType == null) {
            this.record.fieldType = taskType;
          //  alert(this.record.fieldType);
            return;
        }
    }

    public showSaveButton() {
        // if (this.needCheckSaveButton) {
        //     if (this.record && this.record._newUserTask) {
        //         return true;
        //     }
        //     return false;
        // }
        return true;
    }

    validInputAccordingly(fieldType: FieldType): boolean{
        if(fieldType=='IMAGE'  || fieldType=='IMAGE_WITH_CUSTOMIZED_SIZE'  || fieldType=='IMAGE_IN_ROW1'  || fieldType=='IMAGE_IN_ROW2'){
            if(!this.imgFile){
                return false;
            }
        }
        return true;
    }

    public save() {
        this.clickSave = true;
        for (let key of Object.keys(this.modelform.controls)) {
            this.modelform.controls[key].markAsDirty();
        }

        if (!this.validInputAccordingly(this.fieldType)) {
             return;
        }
        if (!this.modelform.valid) {
            return;
        }
        if(this.hasValidPatternError || this.hasValidApplyWordErrorTc || this.hasValidApplyWordError){
            return;
        }
        // this.record.standardDate = this.standardDate;
      //  this.retrieveDataAndValidate(this.record.taskType);
        if (this.invalid) {
            return;
        }
        this.clickSave = false;
        
        this.record.fieldType = this.fieldType;
        this.record.sequence = this.sequence;
        this.record.fieldId = this.fieldId;
        this.record.fieldEnLabel = this.fieldEnLabel;
        this.record.fieldTcLabel = this.fieldTcLabel;
        this.record.fieldEnLabel2 = this.fieldEnLabel2;
        this.record.fieldTcLabel2 = this.fieldTcLabel2;
        this.record.fieldEnDescLabel = this.fieldEnDescLabel;
        this.record.fieldTcDescLabel = this.fieldTcDescLabel;
        this.record.fieldType = this.fieldType;
        this.record.notNull = this.notNull;
        this.record.dropDownValue = this.dropDownValue;
        this.record.description = this.description;
        this.record.descriptionStyle =   this.descriptionStyle;
        this.record.labelStyle = this.labelStyle;
        this.record.inputStyle = this.inputStyle;
        this.record.location = this.location;
        this.record.imgFile = this.imgFile;
        
        this.record.fieldIconCode = this.fieldIconCode;
        this.record.showLabel = this.showLabel;
        this.record.sameToTheField = this.sameToTheField;
        
        this.record.buttonProductPrice = this.buttonProductPrice;
        this.record.buttonLabel = this.buttonLabel;
        this.record.insertCustomizedPriceInput = this.insertCustomizedPriceInput;
        this.record.button4ProductName = this.button4ProductName;
        this.record.button4ProductCode = this.button4ProductCode;
        this.record.imageHeight = this.imageHeight;
        this.record.imageWidth = this.imageWidth;
        this.record.buttonLabelTc = this.buttonLabelTc;
        this.record.dropDownValueTc = this.dropDownValueTc;
        this.record.validPattern = this.validPattern;
        this.record.tandcApplyToWord = this.tandcApplyToWord;
        this.record.tandcApplyToWordTc = this.tandcApplyToWordTc;
        this.record.paddingTopHeight = this.paddingTopHeight;
        this.record.labelBackgroundColor = this.labelBackgroundColor;
        this.record.labelFontColor = this.labelFontColor;
        this.record.labelFontFamily = this.labelFontFamily;
        this.record.fieldBackgroundColor = this.fieldBackgroundColor;
        this.record.labelFontWeight = this.labelFontBold;
        
	    this.record.allowResetProductAmountInUi = this.allowResetProductAmountInUi;   
        this.record.checkedAsDefault = this.checkedAsDefault;
        this.record.showButtonAtTheBottom = this.showButtonAtTheBottom;
        this.record.displayIn = this.displayIn;
        this.record.maxProductAmountInOneBuy = this.allowResetProductAmountInUi?this.maxProductAmountInOneBuy:1;
 

        this.onSave.emit(this.record);
        this.modal.hide();
        this.needInit = false;
    }

    public close(): void {
        this.clickSave = false;
        this.modal.hide();
        this.needInit = false;
    }


    
    downloadFile() {
        let item = this.imgFile;
        this.fileLoading = true;
        item._selected = true;
        this.binaryFileService.downloadFile(item.binaryFileId)
            .subscribe(blob => {

                FileSaver.saveAs(blob, item.fileName);
                this.fileLoading = false;
                item._selected = false;
            }, (error: ErrorResponse) => {
                this.fileLoading = false;
                item._selected = false;
                from(error.errors)
                    .pipe(
                        mergeMap(error => this.translate.get(error.errorCode)),
                        reduce((acc, value) => acc + value + '<br/>', '')
                    )
                    .subscribe(msg => {
                        this.translate.get(item.fileName)
                            .pipe(
                                switchMap(typeStr => this.translate.get('FAIL_TO_DOWNLOAD', { type: typeStr }))
                            )
                            .subscribe(title => {
                                toastr.options = {
                                    "closeButton": true,
                                    "positionClass": "toast-bottom-right",
                                    "timeOut": "0",
                                    "extendedTimeOut": "0"
                                }
                                toastr.error(msg, title);
                            });
                    });
            })
    }

    showDownloadButton() {
        if (!this.imgFile) {
            return false;
        }
        return this.imgFile.binaryFileId != null && !(this.imgFile._selected)
    }

    showLargeDescriptionInput(){
        return  this.fieldType=='BUTTON' ||
         this.fieldType=='BUTTON_CUSTOMIZED_PRICE'
          || ((this.fieldType=='IMAGE' || this.fieldType=='IMAGE_WITH_CUSTOMIZED_SIZE') && (this.location=='A-2' || this.location=='A-3'));
    }

    showLabelPaddingTopHeightInput(){
        return  (this.fieldType=='IMAGE' || this.fieldType=='IMAGE_WITH_CUSTOMIZED_SIZE')
             && (this.location=='A-2' || this.location=='A-3');
    }

    showAccordingToFieldType(targetType:string){
        if(targetType=='sameToTheField'){
            return this.fieldType == 'TEXT' || this.fieldType == 'PHONE';
        }else if(targetType=='displayIn'){
            return ((this.fieldType=='IMAGE' || this.fieldType=='IMAGE_WITH_CUSTOMIZED_SIZE') 
                && (this.location=='A-1' || this.location=='A-2' || this.location=='A-3' || this.location=='TOP-B'));
        }
        return true;
    }

    onImageSizeChange(changeType: string){
        if(changeType=='WIDTH'){
            if(this.imageWidth){
                if(!this.imageWidth.trim().endsWith('%')){
                    this.imageWidth = this.imageWidth.trim()+'%';
                }
            }
        }else{
            if(this.imageHeight ){
                if(!this.imageHeight.trim().toLowerCase().endsWith('px')){
                    this.imageHeight = this.imageHeight.trim()+'px';
                }
            }
        }
    }

    removeDocuments(): void {
        if (!this.imgFile || this.imgFile.fileName == null) {
            return;
        }
        this.imgFile._selected = true;
        this.imgFile = null;
        this.documentFileSelect.nativeElement.value = '';
    }
 
    hasValidPatternError: boolean = false;
    hasValidApplyWordError: boolean = false;
    hasValidApplyWordErrorTc: boolean = false;
    onFieldValidPatternChange(form: NgForm, fieldName: string){
        if(this.validPattern==null || this.validPattern==undefined 
            || this.validPattern.trim()==""){
                this.validPattern = null;
                this.hasValidPatternError = false;
                return false;
        }

        let isReg = false;
        try {
            var tt = eval(this.validPattern);
           tt.test("1");
           this.hasValidPatternError = false;
        } catch (e) {
          isReg = true;
          this.hasValidPatternError = true;
        }
        return isReg;
    }

    isNotValidApplyToWord(type:string){
        if(type=='EN'){
            this.hasValidApplyWordError = !(this.fieldEnLabel && this.fieldEnLabel.indexOf(this.tandcApplyToWord)>=0);
            return this.hasValidApplyWordError;
        }
        this.hasValidApplyWordErrorTc = !(this.fieldTcLabel && this.fieldTcLabel.indexOf(this.tandcApplyToWordTc)>=0)
        return this.hasValidApplyWordErrorTc;
    }
    
    public onAttachmentUploadOutput(output: UploadOutput): void {
        if (output.file != null) {
            this.binaryFileApplication = null;
            if (this.imgFile == null) {
                this.imgFile = new BinaryFile();
            }
            this.binaryFileApplication = new ApplicationFile(output.file, null, MAX_DOCUMENT_FILE_SIZE);
            this.binaryFileApplication.readAsBase64((result) => {
                this.imgFile.content = result;
                this.imgFile.fileName = output.file.name;
                this.imgFile.fileSize = output.file.size;
                this.imgFile._fileName = output.file.name;
                this.imgFile._selected = true;
                this.documentFileSelect.nativeElement.value = '';
            })
        }
    }
 
    
    openProductSelector(){
        var onep = null;
        if(this.button4ProductCode){
            onep = new OnepageProduct();
            onep.productCode = this.button4ProductCode;
            onep.productName = this.button4ProductName;
        }
        this.taskConfigSelector.open(onep);
    }
 

    onTaskConfigSave(event: OnepageProduct) {
        console.log('task config finished ss'+event);
        this.button4ProductCode = event.productCode;
        this.button4ProductName = event.productName;
        this.buttonProductPrice = ""+event.productPrice;
        this.fieldEnLabel = event.productName;
        this.fieldEnDescLabel = event.description;
        this.fieldTcLabel = event.productNameTc;
        this.fieldTcDescLabel = event.descriptionTc;
    }

    showInputAccordingly(fieldId: string, theLangForField:string){
        return this.allowToShow(fieldId) && this.publishLanguage=='EN_AND_TC'|| this.publishLanguage==theLangForField;
    }
}